import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useUser() {
  const queryKey = ref(queryKeys.USER())

  const queryFn = async () => {
    const res = await financialBff('query')({
      user: {
        id: true,
        username: true,
        profile: true,
        fullname: true,
        document: true,
        terms: {
          operating_agreement: {
            is_current_term_accepted: true,
            can_accept: true,
          },
        },
      },
    })
    return res.user
  }

  return useQuery({
    queryFn,
    queryKey,
    retry: 3,
    retryDelay: 1000,
    staleTime: 1000 * 60,
  })
}

export type UseUserData = ReturnType<typeof useUser>['data']['value']
